import { Link, useLocation } from "@tanstack/react-router";
import { useState } from "react";

import DropdownMenu from "$/lib/components/organisms/DropDownMenu/DropdownMenu";
import ChevronUpIcon from "$/lib/icons/ChevronUpIcon";
import type { PathRouteType } from "$/lib/types/routes.types";
import { cn } from "$/lib/utils/functions/misc.functions";

type Props = {
  items: { label: string; route: PathRouteType }[];
};

const HelpMobileNavigation = ({ items }: Props) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const activeItem = items.find((item) => item.route === location.pathname);

  return (
    <DropdownMenu
      open={open}
      onOpenChange={setOpen}
      alignToTrigger="bottom-center"
      triggerContainerClassName="w-full"
      className="w-[calc(100vw-2rem)] max-w-[420px] p-2"
      trigger={
        <button
          type="button"
          className="flex w-full items-center justify-between rounded-xl border border-border bg-white px-4 py-3 text-left shadow-xs"
        >
          <span className="truncate text-[13px] font-semibold text-textColor">
            {activeItem?.label ?? items[0]?.label}
          </span>
          <ChevronUpIcon
            className={cn("shrink-0 transition-transform", !open && "rotate-180")}
            fill="currentColor"
          />
        </button>
      }
    >
      <div className="flex max-h-[60vh] flex-col gap-1 overflow-y-auto">
        {items.map((item, index) => {
          const isActive = item.route === location.pathname;
          return (
            <Link
              key={index}
              to={item.route}
              onClick={() => setOpen(false)}
              className={cn(
                "rounded-lg px-3 py-2.5 text-sm font-medium text-textInfo transition-colors",
                isActive ? "bg-gris-100 text-textColor" : "hover:bg-gris-50",
              )}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </DropdownMenu>
  );
};

export default HelpMobileNavigation;
